<template>
  <v-card outlined class="my-3">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="8">
          <text-field
            v-if="language === 'default'"
            v-model="editedItem.name"
            :label="$t('title')"
            required
            :rules="[rules.required]"
            outlined
            hide-details
            dense
          ></text-field>
          <text-field
            v-else
            v-model="editedItem.translations.find((t) => t.code === language).name"
            :label="$t('title')"
            outlined
            hide-details
            dense
          ></text-field>
        </v-col>
        <v-col cols="12" md="2">
          <text-field
            v-model="editedItem.code"
            :label="$t('item_code')"
            outlined
            dense
            hide-details
          ></text-field>
        </v-col>
        <v-col cols="12" md="2">
          <text-field
            type="number"
            v-model="editedItem.price"
            :label="$t('basic_price')"
            hide-details
            :suffix="currency"
            outlined
            dense
          ></text-field>
        </v-col>
        <v-col cols="12" md="4">
          <autocomplete
            v-model="editedItem.category"
            :items="categories"
            dense
            hide-details
            :label="$t('group_meal')"
            return-object
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
            outlined
            :disabled="readOnlyCategory"
          ></autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <text-field
            v-model="editedItem.note"
            :label="$t('note')"
            outlined
            hide-details
            dense
          ></text-field>
        </v-col>
        <v-col cols="12" md="4">
          <text-area
            v-if="language === 'default'"
            rows="1"
            v-model="editedItem.description"
            :label="$t('description')"
            outlined
            hide-details
            dense
            auto-grow
          ></text-area>
          <text-area
            v-else
            rows="1"
            v-model="editedItem.translations.find((t) => t.code === language).description"
            :label="$t('description')"
            outlined
            hide-details
            dense
            auto-grow
          ></text-area>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import hasValidation from "@/mixins/hasValidation";

export default {
  name: "FoodBasicInfo",
  mixins: [hasValidation],
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: "",
    },
    readOnlyCategory: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: "default"
    }
  },
};
</script>
